import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './interceptor.service';
import { ApiService } from './api.service';

/**
 * KHÔNG dùng APP_INITIALIZER để gọi getUserByToken() ở đây.
 *
 * Trước đây module này có một APP_INITIALIZER chặn bootstrap cho tới khi
 * getUserByToken() xong. Nó tạo ra deadlock khi token MSAL hỏng:
 *
 *   APP_INITIALIZER chặn bootstrap
 *     -> request đi qua InterceptorService
 *     -> acquireTokenSilent fail, interceptor chờ InteractionStatus.None
 *     -> inProgress$ khởi tạo là InteractionStatus.Startup, chỉ về None sau khi
 *        handleRedirectPromise chạy
 *     -> handleRedirectPromise do MsalRedirectComponent kích hoạt
 *     -> MsalRedirectComponent chỉ bootstrap SAU KHI APP_INITIALIZER resolve
 *
 * Khép kín: app không bao giờ bootstrap, người dùng thấy màn hình trắng.
 *
 * Việc nạp thông tin người dùng đã được lo ở hai chỗ khác:
 * - AuthService constructor gọi getUserByToken() khi service được khởi tạo lần đầu
 * - AuthGuard.canActivate await getUserByToken() trước khi cho vào route
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ]
})
export class HttpModule {}
